import { useRef } from "react";
import { FormikProps } from "formik";
import { IReviewBookingDetails } from "./reviewbookingModel";

const ReviewBookingSummary = ({
  formik,
  // setTravellerConfirm,
  INFANT,
  CHILD,
  ADULT,
}: {
  formik: FormikProps<IReviewBookingDetails>;
  // setTravellerConfirm: (confirm: boolean) => void;
  INFANT: number;
  CHILD: number;
  ADULT: number;
}) => {
  const closeBtnRef = useRef<any>(null);
  return (
    <div className="profile-heading">
      <div className="add-travel">
        <div
          className="modal fade"
          id="reviewsummary"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="review-summary"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{ maxWidth: 450 }}
          >
            <div className="modal-content review-booking-dialog">
              <div className="modal-header">
                <h4 className="modal-title fs-5" id="review-summary">
                  Review Details
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body travel-form-detail">
                <div className="travel-form">
                  <div>
                    <p>
                      Please ensure that the spelling of your name and other
                      details match with your travel document/govt. ID, as these
                      cannot be changed later. Errors might lead to cancellation
                      penalties.
                    </p>
                  </div>
                  <div>
                    {ADULT > 0 &&
                      formik?.values?.adults
                        .filter((e: any) => e.isSelected)
                        .map((e, index) => {
                          return (
                            <div className="review-summary-card">
                              <h4>Adult {index + 1}</h4>
                              <table style={{ width: "100%", fontSize: 15 }}>
                                <tr>
                                  <td style={{ width: "50%" }}>First Name</td>
                                  <td
                                    style={{ width: "50%" }}
                                    className="fw-bold"
                                  >
                                    {e?.first_name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Last Name</td>
                                  <td className="fw-bold">{e?.last_name}</td>
                                </tr>
                                <tr>
                                  <td>Gender</td>
                                  <td className="fw-bold">
                                    {e?.initial === "MR" ||
                                    e?.initial === "MSTR"
                                      ? "Male"
                                      : "Female"}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          );
                        })}
                    {CHILD > 0 &&
                      formik?.values?.children
                        .filter((e: any) => e.isSelected)
                        .map((e, index) => {
                          return (
                            <div className="review-summary-card">
                              <h4>Child {index + 1}</h4>
                              <table style={{ width: "100%", fontSize: 15 }}>
                                <tr>
                                  <td style={{ width: "50%" }}>First Name</td>
                                  <td
                                    style={{ width: "50%" }}
                                    className="fw-bold"
                                  >
                                    {e?.first_name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Last Name</td>
                                  <td className="fw-bold">{e?.last_name}</td>
                                </tr>
                                <tr>
                                  <td>Gender</td>
                                  <td className="fw-bold">
                                    {e?.initial === "MR" ||
                                    e?.initial === "MSTR"
                                      ? "Male"
                                      : "Female"}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          );
                        })}
                    {INFANT > 0 &&
                      formik?.values?.infants
                        .filter((e: any) => e.isSelected)
                        .map((e, index) => {
                          return (
                            <div className="review-summary-card">
                              <h4>Infant {index + 1}</h4>
                              <table style={{ width: "100%", fontSize: 15 }}>
                                <tr>
                                  <td style={{ width: "50%" }}>First Name</td>
                                  <td
                                    style={{ width: "50%" }}
                                    className="fw-bold"
                                  >
                                    {e?.first_name}
                                  </td>
                                </tr>
                                <tr>
                                  <td>Last Name</td>
                                  <td className="fw-bold">{e?.last_name}</td>
                                </tr>
                                <tr>
                                  <td>Gender</td>
                                  <td className="fw-bold">
                                    {e?.initial === "MR" ||
                                    e?.initial === "MSTR"
                                      ? "Male"
                                      : "Female"}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          );
                        })}
                  </div>
                </div>
                <div className="travel-detail-btns mt-4">
                  <a
                    className="disable"
                    href="javascript:void(0)"
                    data-bs-dismiss="modal"
                    ref={closeBtnRef}
                  >
                    Edit
                  </a>
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      // setTravellerConfirm(true);
                      formik.handleSubmit();
                      if (closeBtnRef.current) {
                        closeBtnRef.current.click();
                      }
                    }}
                  >
                    Continue
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReviewBookingSummary;
